import { leadStatusesName, leadSourcesName, myCampaignsName, leadStatusesNameColors, myCampaignsNameColors} from './dashboard-chart-section.constant';
import { leadSourcesNameColors } from '../../../leads/lead-reports/lead-source-breakdown/lead-source-breakdown.constant';

export const getLeadStatuses = (data: any) => {
  const leadStatuses = leadStatusesName?.map((item: any,  index: any) => {
    const isDataAdded = data?.find((dataItem: any) => dataItem?.status === item);
    return {
      label: `${item} ${isDataAdded?.percentage || 0}%`,
      value: isDataAdded?.percentage  || 0,
      color: leadStatusesNameColors[index]
    };
  });
  return data?.length > 0 ?  leadStatuses  : [];
}

export const getLeadSources = (data: any) => {
  const leadSources = leadSourcesName?.map((item: any, index: any) => {
    const isDataAdded = data?.find((dataItem: any) => dataItem?.status === item);
    return {
      label: `${item} ${isDataAdded?.percentage || 0}%`,
      value: isDataAdded?.percentage  || 0,
      color: leadSourcesNameColors[index]
    };
  });
  return data?.length > 0 ?  leadSources : [];
}

export const getCampaignsStatus = (data: any) => {
  const campaignsStatus = myCampaignsName?.map((item: any, index: any) => {
    const isDataAdded = data?.find((dataItem: any) => dataItem?.status === item);
    return {
      label: `${item} ${isDataAdded?.percentage || 0}%`,
      value: isDataAdded?.percentage  || 0,
      color: myCampaignsNameColors[index]
    };
  });
  return  data?.length > 0 ? campaignsStatus : [];
}